import React from "react";

const LeftArrow = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M20.5664 10C20.5664 15.5228 16.0893 20 10.5664 20C5.04356 20 0.566406 15.5228 0.566406 10C0.566406 4.47715 5.04356 0 10.5664 0C16.0893 0 20.5664 4.47715 20.5664 10ZM12.5967 5.46967C12.3038 5.17678 11.829 5.17678 11.5361 5.46967L7.53608 9.46967C7.24318 9.76256 7.24318 10.2374 7.53608 10.5303L11.5361 14.5303C11.829 14.8232 12.3038 14.8232 12.5967 14.5303C12.8896 14.2374 12.8896 13.7626 12.5967 13.4697L9.12707 10L12.5967 6.53033C12.8896 6.23744 12.8896 5.76256 12.5967 5.46967Z"
        fill={props.active?"#BEBEBE":"#656565"}
      />
    </svg>
  );
};

export default LeftArrow;
